import fp from 'lodash/fp';
import React from 'react';
import { taskTypes } from './config';

export const noDuplicate = (cid, aoas) => fp.filter(
  ({ cpdCategoryId }) => cid === cpdCategoryId
)(aoas).length === 1

export const validate = ({
  taskName,
  selectedContents,
  externalLink,
  cpdHoursEarned,
  files,
  users,
  existingFiles,
  dueDate },
  type,
  allocateCpd,
  checkBackdate,
  {
    yearUntouched = false,
    monthUntouched = false,
    dayUntouched = false
  }) => ({
    taskName: (taskName && taskName.length > 0) ? undefined : "Task name undefined",
    selectedContents: ((type !== taskTypes.CADDIE) || ((type === taskTypes.CADDIE) && selectedContents.length > 0)) ? undefined : <div>At least one content item needs to be selected</div>,
    externalLink: (type !== taskTypes.EXTERNAL) || ((type === taskTypes.EXTERNAL) && externalLink && externalLink.length > 0) ? undefined : "External link undefined",
    dueDate: (!yearUntouched && !monthUntouched && !dayUntouched) ? ((checkBackdate && (dueDate < new Date())) ? "Due date must be in the future" : undefined) : "Date must be set",
    cpdHoursEarned: cpdHoursEarned.map(
      ({ cpdCategoryId, points }) => ({
        cpdCategoryId: ((cpdCategoryId !== undefined) && noDuplicate(cpdCategoryId, cpdHoursEarned)) ? undefined : "Area of advice is undefined or duplicate",
        points: (points > 0) ? undefined : "Hours allocated must be greater than 0"
      })
    ),
    users: (fp.filter(
      ({ selected }) => selected
    )(users).length > 0) ? undefined : "Select at least one user",
    allocateCpd: (!allocateCpd || (type === taskTypes.CADDIE) || (allocateCpd && (type !== taskTypes.CADDIE) && (cpdHoursEarned.length > 0))) ? undefined : "At least select one category",
    files: (type !== taskTypes.ATTACHMENT) || ((type === taskTypes.ATTACHMENT) && existingFiles.concat(files).length > 0) ? undefined : "At least upload one attachment"
  })

export const isValid = ({
  taskName,
  cpdHoursEarned,
  allocateCpd,
  files,
  users,
  dueDate,
  selectedContents,
  externalLink
}) => (
    (!taskName) &&
    (!dueDate) &&
    (!allocateCpd) &&
    (!files) &&
    (!users) &&
    (!externalLink) &&
    (!selectedContents) &&
    (fp.filter(
      ({ cpdCategoryId, points }) => (cpdCategoryId !== undefined) || (points !== undefined)
    )(cpdHoursEarned).length === 0)
  )


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/validation.js